import type { BreadcrumbData } from '../../../../utils/getBreadcrumbs/getBreadcrumbs';

export type GetCategoryDataProps = BreadcrumbData | undefined | null;

export const getCategoryData = (data: GetCategoryDataProps) => {
  const result: {
    categoryPath: BreadcrumbData;
    categoryPathAsString: string | undefined;
  } = {
    categoryPath: [],
    categoryPathAsString: undefined,
  };

  if (!data) return result;

  result.categoryPath = data;
  result.categoryPathAsString = data.map((pathItem) => pathItem.name).join('/');

  return result;
};
